import { Pipe, PipeTransform } from '@angular/core';
import { CommonDataSetAction, ItemAttrListDataSet } from '@mri/types';

@Pipe({
  name: 'cardDataSetDisable'
})
export class CardDataSetDisablePipe implements PipeTransform {

  transform(prop: ItemAttrListDataSet, actions: CommonDataSetAction, ...arg: []): unknown {
    if (!actions.disableWhen) return false;

    return actions.disableWhen(prop);
  }

}
